/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';
import { EnumUtilities } from '../../../../utils/enum.utilities';
import { DeviceHealthIssueCategory } from '../../../core/models/device-health-error.enum';

@Pipe({
  name: 'deviceHealthCategoryLocalizePipe',
  standalone: true
})
export class DeviceHealthCategoryLocalizePipe implements PipeTransform {
  transform(value: string | null): string | null {
    value = value?.toUpperCase();
    if (!value || !EnumUtilities.isValidEnumValue(value, DeviceHealthIssueCategory)) {
      return null;
    }

    return this._mapToLocalizedErrorString(value);
  }

  private _mapToLocalizedErrorString(input: DeviceHealthIssueCategory): string {
    let localizedString: string = input;

    switch (input) {
      case DeviceHealthIssueCategory.Critical:
        localizedString = $localize`:@@S_HEALTH_STATUS_CRITICAL:Critical`;
        break;
      case DeviceHealthIssueCategory.Major:
        localizedString = $localize`:@@S_HEALTH_STATUS_MAJOR:Major`;
        break;
      case DeviceHealthIssueCategory.Moderate:
        localizedString = $localize`:@@S_HEALTH_STATUS_MODERATE:Moderate`;
        break;
    }

    return localizedString;
  }
}
